import SoraLove from 'src/assets/img/realtalk/sora_top.webp'
import MinatoLove from 'src/assets/img/realtalk/minato_top.webp'
import RenLove from 'src/assets/img/realtalk/ren_top.webp'
import ShoLove from 'src/assets/img/realtalk/sho_top.webp'
import SyunLove from 'src/assets/img/realtalk/syun_top.webp'
import RinLove from 'src/assets/img/realtalk/rin_top.png'
import RitsuLove from 'src/assets/img/realtalk/ritsu_top.png'
import ReiLove from 'src/assets/img/realtalk/rei_top.png'
import SoraSub from 'src/assets/img/realtalk/sora_bg.svg'
import SyunSub from 'src/assets/img/realtalk/suyn_bg.svg'
import ShoSub from 'src/assets/img/realtalk/sho_bg.svg'
import RenSub from 'src/assets/img/realtalk/ren_bg.svg'
import RinSub from 'src/assets/img/realtalk/rin_bg.svg'
import RitsuSub from 'src/assets/img/realtalk/ritsu_bg.svg'
import ReiSub from 'src/assets/img/realtalk/rei_bg.svg'
import MinatoSub from 'src/assets/img/realtalk/minato_bg.svg'
import SoraBtn from 'src/assets/img/realtalk/button_sora.png'
import SyunBtn from 'src/assets/img/realtalk/button_syun.png'
import ShoBtn from 'src/assets/img/realtalk/button_sho.png'
import RenBtn from 'src/assets/img/realtalk/button_ren.png'
import MinatoBtn from 'src/assets/img/realtalk/button_minato.png'
import RinBtn from 'src/assets/img/realtalk/button_rin.png'
import RitsuBtn from 'src/assets/img/realtalk/button_ritsu.png'
import ReiBtn from 'src/assets/img/realtalk/button_rei.png'
import iconCharacterMina from 'src/assets/img/realtalk/realtalk_sd_minato.png'
import iconCharacterRen from 'src/assets/img/realtalk/realtalk_sd_ren.png'
import iconCharacterSho from 'src/assets/img/realtalk/realtalk_sd_sho.png'
import iconCharacterSora from 'src/assets/img/realtalk/realtalk_sd_sora.png'
import iconCharacterSyun from 'src/assets/img/realtalk/realtalk_sd_syun.png'
import iconCharacterRin from 'src/assets/img/realtalk/realtalk_sd_rin.png'
import iconCharacterRitsu from 'src/assets/img/realtalk/realtalk_sd_ritsu.png'
import iconCharacterRei from 'src/assets/img/realtalk/realtalk_sd_rei.png'
import SoraLeft from 'src/assets/img/gacha/sora_left.png'
import MinatoLeft from 'src/assets/img/gacha/minato_left.png'
import SyunLeft from 'src/assets/img/gacha/syun_left.png'
import RenLeft from 'src/assets/img/gacha/ren_left.png'
import ShoLeft from 'src/assets/img/gacha/sho_left.png'
import RinLeft from 'src/assets/img/gacha/rin_left.png'
import RitsuLeft from 'src/assets/img/gacha/ritsu_left.png'
import ReiLeft from 'src/assets/img/gacha/rei_left.png'

const ASHA = '朝日空'
const MINA = '横浜湊'
const REN = '若槻蓮'
const SHO = '風早翔'
const SYUN = '立花駿'
const RIN = '九重燐'
const RITSU = '月城律'
const REI = '伊吹零'

const characterConfig = {
  [ASHA]: {
    imageActive: SoraLove,
    imageGray: SoraSub,
    imgIcon: iconCharacterSora,
    imgButton: SoraBtn,
    imgLeft: SoraLeft
  },
  [MINA]: {
    imageActive: MinatoLove,
    imageGray: MinatoSub,
    imgIcon: iconCharacterMina,
    imgButton: MinatoBtn,
    imgLeft: MinatoLeft
  },
  [REN]: {
    imageActive: RenLove,
    imageGray: RenSub,
    imgIcon: iconCharacterRen,
    imgButton: RenBtn,
    imgLeft: RenLeft
  },
  [SHO]: {
    imageActive: ShoLove,
    imageGray: ShoSub,
    imgIcon: iconCharacterSho,
    imgButton: ShoBtn,
    imgLeft: ShoLeft
  },
  [SYUN]: {
    imageActive: SyunLove,
    imageGray: SyunSub,
    imgIcon: iconCharacterSyun,
    imgButton: SyunBtn,
    imgLeft: SyunLeft
  },
  [RIN]: {
    imageActive: RinLove,
    imageGray: RinSub,
    imgIcon: iconCharacterRin,
    imgButton: RinBtn,
    imgLeft: RinLeft
  },
  [RITSU]: {
    imageActive: RitsuLove,
    imageGray: RitsuSub,
    imgIcon: iconCharacterRitsu,
    imgButton: RitsuBtn,
    imgLeft: RitsuLeft
  },
  [REI]: {
    imageActive: ReiLove,
    imageGray: ReiSub,
    imgIcon: iconCharacterRei,
    imgButton: ReiBtn,
    imgLeft: ReiLeft
  }
}

export const characterSlide = (data) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return
  }
  return data.map((item) => {
    const config = characterConfig[item?.name]
    return config ? { ...item, ...config } : item
  })
}
